import React from "react";
import { IconsFontAwesome } from "../../component/ecovestplantingtree/IconsFontAwesome";
import { PlantingTree } from "../../component/ecovestplantingtree/PlantingTree";
import { Tree } from "../../component/ecovestplantingtree/Tree";
import { useNavigate } from 'react-router-dom';
import "./style.css";

const PlantingTreeScreen = () => {
  const navigate = useNavigate();
  const getTreeClass = (index) => {
    const baseIndex = index + 1;
    if (index === 0) return "tree-instance";
    if (index === 1) return "design-component-instance-node";
    return `tree-${baseIndex}`;
  };
  // Configuration for all PlantingTree components
  const plantingTreeConfigs = [
    ...Array(39).fill(null).map((_, i) => ({
      className: i === 0 ? "planting-tree-instance" : "planting-tree-3",
      imageClassName: `planting-tree-${i + 3}`,
      available: "off"
    })),
    ...Array(36).fill(null).map((_, i) => ({
      imageClassName: `planting-tree-${i + 40}`,
      available: "off"
    })),
    ...Array(15).fill(null).map((_, i) => ({
      imageClassName: `planting-tree-${i + 75}`,
      available: "off"
    })),
    ...Array(5).fill(null).map((_, i) => ({
      imageClassName: `planting-tree-${i + 78}`,
      available: "on"
    })),
    ...Array(16).fill(null).map((_, i) => ({
      imageClassName: `planting-tree-${i + 83}`,
      available: "off"
    })),
    ...Array(14).fill(null).map((_, i) => ({
      imageClassName: `planting-tree-${i + 116}`,
      available: "off"
    })),
    // Group 130-147 (available="on")
    ...Array(18).fill(null).map((_, i) => ({
      imageClassName: `planting-tree-${i + 130}`,
      available: "on"
    })),
    // Group 148-150
    ...Array(3).fill(null).map((_, i) => ({
      imageClassName: `planting-tree-${i + 148}`,
      available: "off"
    })),
    ...Array(7).fill(null).map((_, i) => ({
      imageClassName: `planting-tree-${i + 151}`,
      available: "off"
    })),
    
    ...Array(973).fill(null).map((_, i) => ({
      imageClassName: `planting-tree-${i + 158}`,
      available: "off"
    })),
  ];
  return (
    <div className="planting-tree-screen mx-auto">
      <div className="overlap">
        <div className="map">
          <div className="overlap-group">
            <div className="trees">
            {[...Array(41)].map((_, index) => (
                <Tree 
                  key={index} 
                  className={getTreeClass(index)} 
                  property1="default" 
                />
              ))}
            </div>
            <div className="grid">
              {plantingTreeConfigs.map((config, index) => (
                <PlantingTree
                  key={index}
                  available={config.available}
                  className={config.className}
                  image="/public/assets/images/ecovestplantingtreeimg/image-85-1169.png"
                  imageClassName={config.imageClassName}
                  stateProp="default"
                />
              ))}
            </div>
          </div>
        </div>

        <div className="frame">
          <div className="button-wrapper">
            <button className="button" onClick={() => navigate(-1)}>
              <div className="text-wrapper">Cancel planting</div>
            </button>
          </div>

          <div className="div">Plant (1/3) tree</div>
        </div>
      </div>

      <div className="button-2">
        <IconsFontAwesome
          icon="add"
          iconClassName="icons-font-awesome-instance"
          size="sixteen-px"
        />
        <img className="divider" alt="Divider" src="/public/assets/images/ecovestplantingtreeimg/divider.svg" />

        <IconsFontAwesome
          icon="minus"
          iconClassName="icons-font-awesome-instance"
          size="sixteen-px"
        />
      </div>
    </div>
  );
};
export default PlantingTreeScreen;